export const START_FULL_PAGE_LOADER = 'START_FULL_PAGE_LOADER';
export const STOP_FULL_PAGE_LOADER = 'STOP_FULL_PAGE_LOADER';
export const START_CONTENT_LOADER = 'START_CONTENT_LOADER';
export const STOP_CONTENT_LOADER = 'STOP_CONTENT_LOADER';
export const STOP_ALL_CONTENT_LOADERS = 'STOP_ALL_CONTENT_LOADERS';
export const STOP_ALL_LOADERS = 'STOP_ALL_LOADERS';
export const START_LOGIN_LOADER = 'START_LOGIN_LOADER';
export const STOP_LOGIN_LOADER = 'STOP_LOGIN_LOADER';